import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core/'

class FormCancelButton extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  }

  render() {
    const {
      children,
      ...buttonProps
    } = this.props

    const props = {
      ...buttonProps,
      color: 'default',
      variant: 'text',
    }

    return (
      <Button {...props}>
        { children }
      </Button>
    )
  }
}

export default FormCancelButton
